document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".ai-overall-section").forEach(section => {
    // Coupon copy
    const coupon = section.querySelector(".ai-overall-coupon");
    if (coupon) {
      const code = coupon.dataset.code;
      const tooltip = coupon.querySelector(".tooltip");
      coupon.addEventListener("click", () => {
        navigator.clipboard.writeText(code);
        if (tooltip) {
          tooltip.style.display = "block";
          tooltip.textContent = "Copied!";
          setTimeout(() => {
            tooltip.style.display = "none";
            tooltip.textContent = "Click to Copy";
          }, 1500);
        }
      });
    }

    // Scroll arrows
    const grid = section.querySelector(".ai-overall-grid");
    const left = section.querySelector(".scroll-arrow.left");
    const right = section.querySelector(".scroll-arrow.right");
    if (grid && left && right) {
      left.addEventListener("click", () => grid.scrollBy({ left: -grid.clientWidth * 0.8, behavior: "smooth" }));
      right.addEventListener("click", () => grid.scrollBy({ left: grid.clientWidth * 0.8, behavior: "smooth" }));
    }
  });
});
